// hooks/forms/useTerms.js
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import client from "../utils/Client";

// --- helpers ---
const splitNameExt = (filename = "file.bin") => {
  const i = filename.lastIndexOf(".");
  if (i <= 0) return { base: filename, ext: "bin" };
  return { base: filename.slice(0, i), ext: filename.slice(i + 1).toLowerCase() };
};

// hooks/forms/useTerms.js (or wherever you defined it)
export const fileToBase64Payload = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("Failed to read file"));
    reader.onload = () => {
      const dataUrl = String(reader.result || "");
      const base64 = dataUrl.replace(/^data:.*;base64,/, "");

      const fullName = file.name || "upload.bin";
      const dot = fullName.lastIndexOf(".");
      const fileName = dot > 0 ? fullName.slice(0, dot) : fullName;
      const fileExtension = dot > 0 ? fullName.slice(dot + 1).toLowerCase() : "";

      // 🔑 match server-side C# property names exactly
      resolve({
        FileString: base64,
        FileName: fileName,
        FileExtension: fileExtension,
      });
    };
    reader.readAsDataURL(file);
  });


// --- queries/mutations ---
export const useGetTermsList = (formTypeId) =>
  useQuery({
    queryKey: ["terms", formTypeId],
    queryFn: async () => {
      // Prefer detailed list endpoint (with IDs).
      // If you only have the legacy GET that returns string[],
      // you can map into pseudo objects here.
      const { data } = await client.get(`forms/${formTypeId}/termsAndConditions/list`);
      return data?.result ?? [];
    },
    enabled: !!formTypeId,
    staleTime: 30_000,
  });

export const useUploadTerms = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ formTypeId, payload /* {code, name, extension} */ }) => {
      const { data } = await client.post(
        `forms/${formTypeId}/termsAndConditions`,
        payload
      );
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ["terms", vars.formTypeId] });
    },
  });
};

export const useDeleteTerm = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ formTypeId, termId }) => {
      const { data } = await client.delete(
        `forms/${formTypeId}/termsAndConditions/${termId}`
      );
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ["terms", vars.formTypeId] });
    },
  });
};
